import EMaerket from '~/icons/iconography/emaerket.svg';
import Product from '~/icons/iconography/product.svg';
import Shop from '~/icons/iconography/shop.svg';
import { Item, List, Text } from './styled';
import { useSession } from 'next-auth/react';

const items = [
    {
        text: '30 dages returret',
        icon: <Product height={25} width={25} />,
    },
    {
        text: 'e-mærket',
        icon: <EMaerket height={25} width={25} />,
    },
    {
        text: 'Byt i butik',
        icon: <Shop height={25} width={25} />,
    },
];

const USP = () => {
    const { status } = useSession();

    if (status !== 'unauthenticated') return null;

    return (
        <List aria-label="Unique Selling Points">
            {items.map(({ text, icon }, index) => (
                <Item key={`${text}-${index}`}>
                    {icon}
                    <Text>{text}</Text>
                </Item>
            ))}
        </List>
    );
};

export default USP;
